import classnames from 'classnames';
import { createElement } from 'react';
CardFooter.defaultProps = {
    prefixCls: 'im-card',
};
export default function CardFooter(props) {
    const { prefixCls, content, className, extra, ...restProps } = props;
    const wrapCls = classnames(`${prefixCls}-footer`, className);
    return (createElement("div", Object.assign({ className: wrapCls }, restProps),
        content && (createElement("div", { className: `${prefixCls}-footer-content` }, content)),
        extra && createElement("div", { className: `${prefixCls}-footer-extra` }, extra)));
}
